import classNames from 'classnames';
import {FC, useCallback, useState} from 'react';
import {Placement} from 'react-bootstrap/esm/types';
import {FilterNodeTypeDateRangeContainer} from 'src/js/containers/filtering';
import {DynamicFilter, FILTER_TYPE_DATE_ONLY_RANGE, FILTER_TYPE_DATE_RANGE, Filter} from 'src/js/lib/filtering';
import {FilterNode} from 'src/js/model/filters_config';

import lightFilterNodeStyles from './LightFilterNodeStyles.less';
import {FilterConfig, useFormatters} from './LightFormatter';
import {ShortcutEnum} from '../../../lib/filtering/shortcut_enum';
import DateRangeFilter from '../../../lib/filtering/filters/date_range_filter';

type Props = {
  config: FilterConfig;
  value: {startDate: string; endDate: string; shortcut?: ShortcutEnum | null} | null | undefined;
  onChange?: (newValue: {startDate: string; endDate: string; shortcut?: ShortcutEnum | null} | null) => void;
  dateOnly?: boolean;
  isDefaultValue?: boolean;
  placement?: Placement;
  fullWidth?: boolean;
  enableFuture?: boolean;
  showShortcuts?: boolean;
  isLabResults?: boolean;
  isMedications?: boolean;
};
export const LightDateRangeFilter: FC<Props> = (props) => {
  const {
    config: _config,
    value,
    onChange,
    dateOnly,
    isDefaultValue,
    placement = 'bottom-start',
    fullWidth = false,
    enableFuture = false,
    showShortcuts,
    isLabResults,
    isMedications = false,
  } = props;
  const filterType = dateOnly ? FILTER_TYPE_DATE_ONLY_RANGE : FILTER_TYPE_DATE_RANGE;
  const {t} = useFormatters();
  const config = {
    ..._config,
    ui: {
      label: t(_config.ui.label),
      placeholder: _config.ui.placeholder ? t(_config.ui.placeholder) : _config.ui.placeholder,
      type: filterType,
    },
  };
  const [isOpened, setIsOpened] = useState(false);
  const toggleOpened = useCallback(() => {
    setIsOpened((v) => !v);
  }, []);
  const DateRangeFilter = DynamicFilter.getFilterClass(filterType);
  const filter = value
    ? new DateRangeFilter({
        type: filterType,
        property: config.name,
        value,
      })
    : undefined;
  const changeFilter = useCallback(
    (newFilter: DateRangeFilter) => {
      const [startDate, endDate] = newFilter.getValue();
      let shortcut: ShortcutEnum | null | undefined;
      if ('getShortcut' in newFilter) {
        shortcut = newFilter.getShortcut();
      }
      if (onChange) onChange({startDate, endDate, shortcut});
    },
    [onChange]
  );
  const removeFilter = useCallback(
    (_newFilter: DateRangeFilter) => {
      if (onChange) onChange(null);
    },
    [onChange]
  );
  const inputRef = useCallback(() => {
    // do nothing
  }, []);
  const setFocus = useCallback(() => 0, []);
  const node = new FilterNode(config);
  return (
    <span className={classNames(lightFilterNodeStyles.dlFilterNodeContent, 'dlFilterNode')} data-name={config.name}>
      <FilterNodeTypeDateRangeContainer
        node={node}
        isOpened={isOpened}
        toggleOpened={toggleOpened}
        changeFilter={changeFilter}
        removeFilter={removeFilter}
        selectedFilter={filter}
        inputRef={inputRef}
        setFocus={setFocus}
        isMui
        dateOnly={dateOnly}
        isDefaultValue={isDefaultValue}
        placement={placement}
        fullWidth={fullWidth}
        enableFuture={enableFuture}
        showShortcuts={showShortcuts}
        isLabResults={isLabResults}
        isMedications={isMedications}
      />
    </span>
  );
};
